import TrelloPowerUp from './index';

// eslint-disable-next-line func-names
(function () {
  // eslint-disable-next-line global-require
  window.TrelloPowerUp = new TrelloPowerUp();
}());
